import { useEffect } from 'react';
import { useAppDispatch } from 'redux/hooks';
import { measureAbTestForRegistSuggestionBanner } from '../logics/analytics';

/**
 * Custom hook to measure AB test for a banner.
 * @param {string} abTestForSignUp - The identifier for the AB test related to sign-up.
 * @param {string} eventType - The type of event to be measured.
 */
export const useMeasureAbTestForBanner = (
  abTestForSignUp: string,
  eventType: string
) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
      measureAbTestForRegistSuggestionBanner(abTestForSignUp, eventType)
    );
  }, [abTestForSignUp, eventType, dispatch]);
};
